module.exports = __webpack_public_path__ + "media/golden_skin.c8435a1a.webm";